const TablePosition = require('../TablePosition')

/**
 * Move selection to {x,y}
 *
 * @param {Object} opts
 * @param {Slate.Transform} transform
 * @param {Number} x
 * @param {Number} y
 * @return {Slate.Transform}
 */
function moveSelection (opts, transform, x, y) {
  const { state } = transform
  let { startBlock, startOffset } = state

  if (!TablePosition.isInCell(state, startBlock, opts)) {
    throw new Error('moveSelection can only be applied in a cell')
  }

  const pos = TablePosition.create(state, startBlock, opts)
  const { table } = pos

  const rowsLength = table.nodes.size
  const columnsLength = table.nodes.get(0).nodes.size

  x = x < 0 ? 0 : x
  x = x > columnsLength - 1 ? columnsLength - 1 : x
  y = y < 0 ? 0 : y
  y = y > rowsLength - 1 ? rowsLength - 1 : y

  const row = table.nodes.get(y)
  const cell = row.nodes.get(x)

    // Calculate new offset
  if (startOffset > cell.length) {
    startOffset = cell.length
  }

  return transform
        .collapseToEndOf(cell)
        .moveOffsetsTo(startOffset)
        .focus()
}

module.exports = moveSelection



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/deep-table-plugin/transforms/moveSelection.js